import { createContext } from "react";

const PusherContext = createContext({
  tiggerPusherMessage: () => console.log("Hello"),
  unSubscribeChannel: () => console.log("Unsubscribe"),
  //   notiData: null,
  //   setNotiData: () => console.log("clear Noti Data"),
});
export default PusherContext;
